import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments';
import { RevisionReason, TreatmentTypeList, TreatmentTypeListCard } from '../models';
import { map, Observable } from 'rxjs';
import { RegionListOptionsClient } from './region-list-options.client';
// import { AppTreatmentTypes } from 'app/core/constants';

const basePath = `${environment.apiBaseUrl}treatment-type`;

@Injectable({ providedIn: 'root' })
export class TreatmentTypeApiClient {
    private readonly _http = inject(HttpClient);
    private readonly _regionListOptionsClient = inject(RegionListOptionsClient);

    getRegionCardOptions(parentId?: number): Observable<TreatmentTypeListCard[]> {
        return this._http
            .get<TreatmentTypeListCard[]>(`${basePath}/region-card-options${parentId ? `/${parentId}` : ''}`)
            .pipe(map(items => [...items.sort((a, b) => a.id - b.id)]));
    }

    getRegionListOptions(): Observable<TreatmentTypeList[]> {
        return this._regionListOptionsClient
            .getRegionListOptions<TreatmentTypeList>('treatment-type')
            .pipe(map(items => [...items.sort((a, b) => a.id - b.id)]));
    }

    getTypeReasons(productTypeId: number): Observable<RevisionReason[]> {
        return this._http.get<RevisionReason[]>(`${basePath}/${productTypeId}/revision-reason`);
    }
}
